// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__h9C8c","modalLight":"styles_modalLight__g-G4w","transparent":"styles_transparent__pe0Ys","mobileModalBody":"styles_mobileModalBody__7KoAy"};